export default {
  'settings.name': 'System installation',

  //collection
  'collection.name': 'Collection',

  //category
  'category.name': 'Group name',
  'category.code': 'Group code',
  'category.itemQuantity': 'Number of items in the group',
  'category.action': 'Act',
  'category.router.name': 'Item group',
  'category.title': 'Manage the item group',
  'category.update': 'Update the item group',
  'category.information': 'Information group information',
  'category.create': 'Create an item group',
  'category.title.delete': 'Delete the item group',
  'category.content.delete': 'Are you sure you want to delete this group of items.',
  //users
  'users.name': 'User',

  //rankTimeSetting
  'rankTimeSetting.name': 'Time to close the rankings',
  'rankTimeSetting.title': 'Set the time to close the rankings',
  'rankTimeSetting.time': 'Bonus time',
  'rankTimeSetting.dateTime': 'Program operation time',
  'rankTimeSetting.placeholder.dayOfWeek': 'Choose the week',
  'date.0': 'Sunday',
  'date.1': 'Monday',
  'date.2': 'Tuesday',
  'date.3': 'Wednesday',
  'date.4': 'Thursday',
  'date.5': 'Friday',
  'date.6': 'Saturday',

  //errors
  'errors.name': 'Type of error',
  'errors.title': 'Manage the type of error',
  'errors.errorType.code': 'Type of error',
  'errors.content': 'Error content',
  'errors.createdAt': 'Duration of error report',
  'errors.status': 'Processing',
  'errors.status.param': '{status, select, 1 {Processed} 2 {Not processed} other {unknown}}',
  'errors.check': 'Handle',
  'errors.title.warning': 'Can not handle the error',
  'errors.content.warning': 'You cannot handle the processed state error',
  'errors.title.delete': 'Handle errors',
  'errors.content.delete': 'Are you sure you want to handle this error?',
  'errors.information': 'Error information',
  'errors.contact': 'Contact Information',

  'rankTimeSetting.limitSwap': 'Number of swap faces per day',
};
